export default __webpack_public_path__ + "img/fCfJkvyY.52ed3986.svg";